import React from "react";

import { images } from "../../constants";
import "./Manuscript.css";

const Manuscript = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_info">
      <h1 className="headtext__cormorant">Manuscript</h1>

      <div className="app__author-content">
        <div className="app__author-content_quote">
          <p className="p__opensans_lower_case">
            “[The night sky through the perspective of a camera] This is what
            the night sky looked like 100 years ago. This is what the night sky
            looked like 30 years ago. This is what the night sky looks like
            today. Look, there are no stars. Look! There! Those two lights! They
            look very pretty–surely those are stars twinkling in the distance—
            but those aren’t stars, they’re satellites. Or, if they’re blinking,
            it’s an airplane. [image of a satellite in the sky] … A long time
            ago, in a Korean village off the province of South Gyeongsang,
            people used paper lanterns to see at night. And every night the
            people made sure to turn off their lanterns, or else their house
            might catch on fire. [image of a burning paper lantern alongside
            someone reading] The village was known for its beautiful landscapes,
            and many people would visit to go hiking. But, what most people did
            not know, was that the village was home to creatures called the
            Myōjā. They had long, hollow eyes. They were as tall as red pine
            trees. They ate white moths and loved to play games with the village
            children. They went to sleep at night, and woke up with the morning
            sun, the same as the village people. They helped pick up trash left
            by the visiting hikers, and they lifted away heavy trees and rocks
            which fell by the wayside.”
          </p>
        </div>
      </div>
    </div>
    <div className="app__aboutus-content_knife flex__center">
      <img src={images.Sky} alt="Night sky before and after" />/
    </div>
  </div>
);

export default Manuscript;
